export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8455.cc9163bd.jpg";